export const visit = (vm, at) => {
at({ "en": { "breezeSetupDealAutomations": { "setupPrompt": "Help me set up deal automations." } } });
};